// O CÉREBRO DA MARCA (PROMPT 206): os sinais que a tela manda e o evento do "Aprendi". O sinal é fogo e esquece: aprender
// nunca atrapalha quem está salvando ou aprovando.
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const EVENTO_APRENDI = 'cerebro_aprendi';

export const avisarAprendi = (regra) => {
  if (regra?.id) window.dispatchEvent(new CustomEvent(EVENTO_APRENDI, { detail: regra }));
};

export const registrarSinal = async (tipo, origem, campos = {}) => {
  try {
    const { data } = await axios.post(`${API}/cerebro/sinal`, { tipo, origem, ...campos });
    return data?.aprendi || null;
  } catch {
    return null;
  }
};

const CAMPOS_DE_TEXTO = ['titulo', 'subtitulo', 'cta', 'texto_apoio', 'legenda_post'];

/** O texto da copy do card, numa linha por campo: é o que uma aprovação guarda como referência. */
export const textoDaCopy = (copia) => {
  const c = copia || {};
  const linhas = CAMPOS_DE_TEXTO.map((k) => c[k]).filter(Boolean);
  (c.slides || []).forEach((s) => CAMPOS_DE_TEXTO.forEach((k) => { if (s?.[k]) linhas.push(s[k]); }));
  return linhas.join('\n');
};

export const lerCerebro = () => axios.get(`${API}/cerebro`).then((r) => r.data);
export const desfazerRegra = (id) => axios.delete(`${API}/cerebro/regras/${id}`);
export const editarRegra = (id, texto) => axios.patch(`${API}/cerebro/regras/${id}`, { texto }).then((r) => r.data.regra);
export const gravarCorrecao = (item, correcao, origem) => axios.post(`${API}/cerebro/corrigir`, { item, correcao, origem }).then((r) => r.data);
export const refazerTexto = (item, correcao, conteudo, formato) => axios.post(`${API}/cerebro/refazer`, { item, correcao, conteudo, formato: formato || '' }).then((r) => r.data);
export const lerMapa = () => axios.get(`${API}/cerebro/mapa`).then((r) => r.data);
export const apagarDoCerebro = (caminho) => axios.delete(`${API}/cerebro/${caminho}`);
export const salvarMemoria = (fatos, decisoes) => axios.put(`${API}/cerebro/memoria`, { fatos, decisoes });
